import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/customer';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async add(params: any) {
    return api.add(params);
  }

  @Action
  async edit(params: any) {
    return api.edit(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async delete(params: any) {
    return api.delete(params);
  }

  @Action
  async stadiums(params: any) {
    return api.stadiums(params);
  }

  @Action
  async admin(params: any) {
    return api.admin(params);
  }

  @Action
  async editadmin(params: any) {
    return api.editadmin(params);
  }

  @Action
  async selectdata(params: any) {
    return api.selectdata(params);
  }

  @Action
  async removeadmin(params: any) {
    return api.removeadmin(params)
  }
}
